import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

const AffiliationTagId = () => {
    const history = useHistory();
    const { eventId } = useParams(); // "123" from URL

    useEffect(() => {
        if (eventId) {
            localStorage.setItem('eventid', eventId);
            localStorage.setItem('event_affiliation_source', 'true'); // Set the source to tru
            history.push('/conference/particpant-verification');
        }
    }, [eventId, history]);

    return null;
};

export default AffiliationTagId;




// import React, { useEffect } from 'react';
// import { useHistory, useLocation } from 'react-router-dom';

// const AffiliationTagId = () => {
//     const history = useHistory();
//     const location = useLocation();

//     useEffect(() => {
//         const hashParts = location.hash.split('/');
//         const tag = hashParts[2];      // 'ed'
//         const eventId = hashParts[3];  // '60'

//         if (tag && eventId) {
//             localStorage.setItem('event_tag', tag);
//             localStorage.setItem('eventid', eventId);
//             history.push('/conference/particpant-verification');
//         }
//     }, [location, history]);

//     return null; // This component just runs logic and redirects
// };

// export default AffiliationTagId;
